import React, { createContext, useContext } from "react";
import { useParams } from "react-router-dom";

import { useTouchpoint, type TouchpointAttributes } from "hooks/api/use-touchpoints";

const CurrentTouchpointContext = createContext<TouchpointAttributes | null>(null);

export const CurrentTouchpointProvider = ({
  touchpoint,
  children,
}: React.PropsWithChildren<{ touchpoint: TouchpointAttributes }>) => (
  <CurrentTouchpointContext.Provider value={touchpoint}>
    {children}
  </CurrentTouchpointContext.Provider>
);

export function useCurrentTouchpoint(): TouchpointAttributes {
  const contextTouchpoint = useContext(CurrentTouchpointContext);
  const { touchpointId } = useParams<{ touchpointId: string }>();
  const { data } = useTouchpoint(
    touchpointId ?? "",
    {
      enabled: !contextTouchpoint && !!touchpointId,
    },
  );

  const attributes = contextTouchpoint ?? data;

  if (!attributes) {
    throw new Error("useCurrentTouchpoint: called before a touchpoint was cached");
  }

  return attributes;
}
